import { IAction } from 'helpers/interfaces';
import { Messages } from 'utils';
import { ApiAccessTypes } from '../../actions/configProvider/api-access-actions';

export interface IApiAccessState {
    roles: any[] | null;
    rolesLoading: boolean;
    users: any[] | null;
    totalRecords: number;
    usersLoading: boolean;
    createUserLoading: boolean;
    createUserSuccess: boolean | null;
    createUserResult: any | null;
    updateUserLoading: boolean;
    updateUserSuccess: boolean | null;
    updatePasswordLoading: boolean;
    updatePasswordSuccess: boolean | null;
    updatePasswordResult: any | null;
    userDetails: any | null;
    userLoading: boolean;
    endpoints: any[] | null;
    endpointsLoading: boolean;
}

const initialState: IApiAccessState = {
    roles: null,
    rolesLoading: false,
    users: null,
    totalRecords: 0,
    usersLoading: false,
    createUserLoading: false,
    createUserSuccess: null,
    createUserResult: null,
    updateUserLoading: false,
    updateUserSuccess: null,
    updatePasswordLoading: false,
    updatePasswordSuccess: null,
    updatePasswordResult: null,
    userDetails: null,
    userLoading: false,
    endpoints: null,
    endpointsLoading: false,
};

const apiAccessReducer = (state = initialState, actions: IAction) => {
    switch (actions.type) {
        case ApiAccessTypes.API_ACCESS_ROLES_REQUEST:
            return {
                ...state,
                rolesLoading: true,
            };
        case ApiAccessTypes.API_ACCESS_ROLES_SUCCESS:
            return {
                ...state,
                rolesLoading: false,
                roles: actions.payload?.content || actions.payload?.data || actions.payload || [],
            };
        case ApiAccessTypes.API_ACCESS_ROLES_FAILED:
            return {
                ...state,
                rolesLoading: false,
            };
        case ApiAccessTypes.API_ACCESS_USERS_REQUEST:
            return {
                ...state,
                usersLoading: true,
            };
        case ApiAccessTypes.API_ACCESS_USERS_SUCCESS:
            return {
                ...state,
                usersLoading: false,
                users: actions.payload?.data || actions.payload?.content || [],
                totalRecords:
                    actions.payload?.totalRecords ??
                    actions.payload?.total ??
                    actions.payload?._metadata?.totalNumberOfElements ??
                    0,
            };
        case ApiAccessTypes.API_ACCESS_USERS_FAILED:
            return {
                ...state,
                usersLoading: false,
            };
        case ApiAccessTypes.API_ACCESS_CREATE_USER_REQUEST:
            return {
                ...state,
                createUserLoading: true,
                createUserSuccess: null,
                createUserResult: null,
            };
        case ApiAccessTypes.API_ACCESS_CREATE_USER_SUCCESS:
            Messages.success('API user was successfully created');

            return {
                ...state,
                createUserLoading: false,
                createUserSuccess: true,
                createUserResult: actions.payload || null,
            };
        case ApiAccessTypes.API_ACCESS_CREATE_USER_FAILED:
            return {
                ...state,
                createUserLoading: false,
                createUserSuccess: false,
            };
        case ApiAccessTypes.API_ACCESS_CREATE_USER_CLEAR_STATUS:
            return {
                ...state,
                createUserSuccess: null,
                createUserResult: null,
            };
        case ApiAccessTypes.API_ACCESS_UPDATE_USER_REQUEST:
            return {
                ...state,
                updateUserLoading: true,
                updateUserSuccess: null,
            };
        case ApiAccessTypes.API_ACCESS_UPDATE_USER_SUCCESS:
            Messages.success('API user was successfully updated');

            return {
                ...state,
                updateUserLoading: false,
                updateUserSuccess: true,
            };
        case ApiAccessTypes.API_ACCESS_UPDATE_USER_FAILED:
            return {
                ...state,
                updateUserLoading: false,
                updateUserSuccess: false,
            };
        case ApiAccessTypes.API_ACCESS_UPDATE_USER_CLEAR_STATUS:
            return {
                ...state,
                updateUserSuccess: null,
            };
        case ApiAccessTypes.API_ACCESS_UPDATE_PASSWORD_REQUEST:
            return {
                ...state,
                updatePasswordLoading: true,
                updatePasswordSuccess: null,
                updatePasswordResult: null,
            };
        case ApiAccessTypes.API_ACCESS_UPDATE_PASSWORD_SUCCESS:
            Messages.success('API user password was successfully updated');

            return {
                ...state,
                updatePasswordLoading: false,
                updatePasswordSuccess: true,
                updatePasswordResult: actions.payload || null,
            };
        case ApiAccessTypes.API_ACCESS_UPDATE_PASSWORD_FAILED:
            return {
                ...state,
                updatePasswordLoading: false,
                updatePasswordSuccess: false,
            };
        case ApiAccessTypes.API_ACCESS_UPDATE_PASSWORD_CLEAR_STATUS:
            return {
                ...state,
                updatePasswordSuccess: null,
                updatePasswordResult: null,
            };
        case ApiAccessTypes.API_ACCESS_USER_REQUEST:
            return {
                ...state,
                userLoading: true,
            };
        case ApiAccessTypes.API_ACCESS_USER_SUCCESS:
            return {
                ...state,
                userLoading: false,
                userDetails: actions.payload,
            };
        case ApiAccessTypes.API_ACCESS_USER_FAILED:
            return {
                ...state,
                userLoading: false,
            };
        case ApiAccessTypes.API_ACCESS_USER_ENDPOINTS_REQUEST:
            return {
                ...state,
                endpointsLoading: true,
            };
        case ApiAccessTypes.API_ACCESS_USER_ENDPOINTS_SUCCESS:
            return {
                ...state,
                endpointsLoading: false,
                endpoints: actions.payload || [],
            };
        case ApiAccessTypes.API_ACCESS_USER_ENDPOINTS_FAILED:
            return {
                ...state,
                endpointsLoading: false,
            };
        case ApiAccessTypes.API_ACCESS_CLEAR_DETAILS:
            return {
                ...state,
                userDetails: null,
                endpoints: null,
            };
        default:
            return state;
    }
};

export default apiAccessReducer;
